import { useEffect } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../features/table/helpers';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { useFormStore } from '../../../../store/use-form-store';
import { SortType } from '../../../../types/props';
import { defaultViewStyle, viewStyleKey } from '../../../../helpers/path';

export const useFormsList = () => {
  const { isLoadingFetch, fetchFormList, restoreForm, deleteForm } = useFormStore();

  const { t } = useLang();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const ts = params['ts'];

  const name = params.name;

  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  useEffect(() => {
    fetchFormList({
      name,

      field: sortField,
      dir: sortDirection,

      since_id: 0,
      n: 1000,
      with_archive: true,
      is_by_company: true,
    });
  }, [fetchFormList, name, sortDirection, sortField, ts, viewStyle]);

  return {
    isLoadingFetch,
    t,
    restoreForm,
    deleteForm,
    viewStyle,
  };
};
